import { MTSidebarProps } from '@/multi-territory/mt-types/mt-shared'
import { MTSidebar } from './MTSidebar'

/**
 * Single sidebar for all countries.
 * MTSidebar internally uses useSidebarConfig which resolves the correct
 * routes based on countryCode (India routes vs MT routes via sidebar-config.json).
 */
export function MTSidebarSwitcher(props: MTSidebarProps) {
  return <MTSidebar {...props} />
}
